module.exports = __webpack_public_path__ + "img/ic_chevron_left.c6215c50.svg";